import * as React from 'react';

import { PostCardLayoutLongread, PostCardLayoutWithSidebar } from '../../components/PostCardLayouts';
import { SidebarContainer } from '../Sidebar';

export const PostCard = () => {
  const layoutType: 'with-sidebar' | 'longread' = 'with-sidebar';
  const LayoutComponent: typeof PostCardLayoutLongread | typeof PostCardLayoutWithSidebar =
    // @ts-ignore
    layoutType === 'longread' ? PostCardLayoutLongread : PostCardLayoutWithSidebar;

  return <LayoutComponent sidebarNode={<SidebarContainer />}>Одиночная страница</LayoutComponent>;
};
